import React, { useEffect, useRef, useState } from "react";
import CardSimple from "Components/CardSimple";
import GameLevelIcons from "Components/GameLevelIcons";
import { gameServerApi } from "services/gameServerV2";
import MilestoneProgressBar from "./MilestoneProgressBar";
import classNames from "classnames";
import ProgressLevelModal from "Components/WorkoutOverViewPage/ProgressLevelModal";
import { ProgressLevelModalRef } from "../ProgressLevelModal/ProgressLevelModal";
import { useGetAllLevelAchievement } from "../ProgressLevel/ProgressLevel.action";
import style from "./OlympianCardV2.module.scss";


export interface Remaining {
    value: number;
    hour: number;
    minute: number;
  }
  
  export interface MilestoneDetail {
    id: number;
    name: string;
    targetValue: number;
    value: number;
    progress: number;
    remaining: Remaining;
  }
  
  export interface Milestones {
    currentId: number;
    nextId: number;
    count: number;
    details: MilestoneDetail[];
  }
  
  export interface MetadataLevel {
    id: number;
    name: string;
    baseValue: number;
    targetValue: number;
    iconUrl: string;
    milestonesCount: number;
  }
  
  export interface ProgressLevelData {
    value: number;
    progress: number;
    remaining: Remaining;
    milestones: Milestones;
    nextId: number;
    metadata: {
      current: MetadataLevel;
      next: MetadataLevel;
    };
  }
  
const OlympianCardV2 = () => {
    const [gameUserLevel, setGameUserLevel] = useState<ProgressLevelData | null>(null);
    const [percentProgressText, setPercentProgressText] =
        useState<string>("---");
    const [isMaxLevel, setIsMaxLevel] = useState<boolean>(false);
    const [timeProgressText, setTimeProgressText] = useState<string>("---");
    const progressLevelModalRef = useRef<ProgressLevelModalRef>(null);
    const { data: levels } = useGetAllLevelAchievement();

    useEffect(() => {
        gameServerApi.user.getUserStats().then((res) => {
            setGameUserLevel(res?.data?.userLevel);
        });
    }, []);

    const getRemainingTimeText = (remaining: {
        hour: number;
        minute: number;
        value: number;
    }) => {
        const { hour, minute } = remaining;
        if (hour > 0) {
            const hourText = hour === 1 ? "HOUR" : "HOURS";
            if (minute > 0) {
                if (minute === 1) {
                    return `${hour} ${hourText} ${minute} MINUTE`;
                }
                return `${hour} ${hourText} ${minute} MINUTES`;
            } else {
                return `${hour} ${hourText}`;
            }
        } else if (hour === 0 && minute > 0) {
            if (minute === 1) {
                return `${minute} MINUTE`;
            }
            return `${minute} MINUTES`;
        } else {
            return "";
        }
    };

    const handleFormatImage = (url: string) => {
        if(!url || typeof url !== "string") return "";
        const hasPngExtension = url.endsWith(".png");
        if(!hasPngExtension) return "";
        return url.replace(".png", "_128x128.png");
    }

    useEffect(() => {
        if (gameUserLevel) {
            if(gameUserLevel?.progress===100) {
                setIsMaxLevel(true);
                setPercentProgressText(gameUserLevel?.metadata?.current?.name);
                setTimeProgressText(`you've reached the max level`)
            } else {
                const milestoneDetail = gameUserLevel?.milestones?.details;
                for (let i = 0; i < milestoneDetail.length; i++) {
                    const item = milestoneDetail[i];
                    if (milestoneDetail.length > 1) {
                        if (item.progress !== 100 && item.progress > 0) {
                            //Caculate time progress
                            const timeText = getRemainingTimeText(item?.remaining);
                            setTimeProgressText(`${timeText} TO ${item?.name}`);
                           
                        }
                    } else {
                        //Caculate time progress
                        const timeText = getRemainingTimeText(item?.remaining);
                        setTimeProgressText(`${timeText} TO ${item?.name}`);
                    }
                }
                setPercentProgressText(
                    `${gameUserLevel?.progress}% TO ${
                        gameUserLevel?.metadata?.next?.name || "---"
                    }`
                );
                setIsMaxLevel(false)
            }
        }
    }, [gameUserLevel]);

    return (
        <div className={style["OlympianV2CardWrapper"]}>
            <CardSimple>
                {gameUserLevel && (
                    <div className={style["row"]}
                        onClick={() => {
                            progressLevelModalRef.current?.setIsVisible(true);
                        }}
                    >
                        <div className={style["icon"]}>
                            <GameLevelIcons
                                id={
                                    isMaxLevel
                                        ? gameUserLevel?.metadata?.current
                                              ?.id 
                                        : gameUserLevel?.metadata?.next?.id 
                                          
                                }
                                iconSrc={isMaxLevel ? handleFormatImage(gameUserLevel?.metadata?.current?.iconUrl): handleFormatImage(gameUserLevel?.metadata?.next?.iconUrl)}
                            />
                        </div>
                        <div className={style["progressWrapper"]}>
                            <div className={style["progressHeader"]}>
                                {percentProgressText}
                            </div>
                            <div className={style["remainText"]}>
                                <div
                                    className={classNames(
                                        style["timeProgressText"]
                                    )}
                                >
                                    {timeProgressText}
                                </div>
                            </div>
                            <div className={style["progressBarWrapper"]}>
                                <MilestoneProgressBar
                                    data={
                                        gameUserLevel?.milestones.details || []
                                    }
                                    percentProcess={gameUserLevel?.progress}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </CardSimple>
            <ProgressLevelModal ref={progressLevelModalRef} levels={levels} gameUserLevel={gameUserLevel} />
        </div>
    );
};

export default OlympianCardV2;
